<template>
  <guest-layout background-class="bg-white" :color-scheme="'dark'" :poper-absolute="true">

    <main class="mt-8 sm:mt-0">

      <div class="bg-gray-900 relative isolate overflow-hidden bg-gradient-to-b from-primary-100/20">
        <div class="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40">
          <div v-motion-slide-left class="px-6 lg:px-0 lg:pt-4">
            <div class="mx-auto max-w-2xl">
              <div class="max-w-lg">
                <h2 class="text-base font-semibold leading-7 text-primary-400">{{ __('Stay Ahead of SSL Certificate Expiry') }}</h2>
                <h3 class="mt-2 text-4xl font-bold tracking-tight text-white sm:text-6xl">{{ __('SSL Monitoring - Ensuring Secure') }}</h3>
                {{ ' ' }}
                <span class="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl text-primary-400">
                  {{ __('Connections') }}
                </span>
                <p class="mt-6 text-lg leading-8 text-gray-400">{{ __('With LIVCK\'s SSL monitoring feature, you can proactively monitor the expiration status of your SSL certificates. Our system will send you alerts as your certificates approach expiration at intervals of 90, 60, 30, 14, and 7 days. This ensures that you have ample time to renew or replace your certificates, preventing any disruptions in secure connections and maintaining the trust of your users.') }}</p>
<!--                <div class="mt-10 flex items-center gap-x-6">-->
<!--                  <a target="_blank" href="https://help.livck.com" class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">{{ __('Documentation') }}</a>-->
<!--                  <a target="_blank" href="https://github.com/LIVCK" class="text-sm font-semibold leading-6 text-gray-900">{{ __('View on GitHub') }} <span aria-hidden="true">→</span></a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:w-screen">
            <div class="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-gray-900 shadow-xl shadow-primary-600/10 ring-1 ring-primary-50 md:-mr-20 lg:-mr-36" aria-hidden="true" />
            <component :is="secureIcon" class="mx-auto text-primary-400 h-48 w-48" v-motion-up-down/>
          </div>
        </div>
        <div class="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-gray-900 sm:h-32" />
      </div>

      <div class="bg-white py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-2xl lg:text-center">
<!--            <h2 class="text-base font-semibold leading-7 text-primary-600">{{ __('') }}</h2>-->
            <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ __('The Importance of SSL Monitoring') }}</p>
            <p class="mt-6 text-lg leading-8 text-gray-600">{{ __('SSL certificates play a crucial role in establishing trust and securing sensitive data transmitted between your website and its users. By having SSL monitoring in place, you gain several benefits:') }}</p>
          </div>
          <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
            <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
              <div v-for="feature in features" :key="feature.name" class="relative pl-16">
                <dt class="text-base font-semibold leading-7 text-gray-900">
                  <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                    <component :is="feature.icon" class="h-6 w-6" aria-hidden="true" />
                  </div>
                  {{ __(feature.name) }}
                </dt>
                <dd class="mt-2 text-base leading-7 text-gray-600">{{ __(feature.description) }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <hr class="divider"/>

<!--      <cheap-package-preview-box :bg-from="'bg-white'" :bg-to="'bg-white'"/>-->

      <package-pricing-boxes/>

      <hr class="divider"/>

      <feature-preview-box/>

      <c-t-a-r2-dive-in/>

    </main>

  </guest-layout>
</template>

<script setup>
import GuestLayout from "@/Layouts/GuestLayout";
import VueWriter from 'vue-writer';

import {defineComponent, h} from "vue";
import FeaturePreviewBox from "@/Pages/Sites/FeatureSections/FeaturePreviewBox";
import CheapPackagePreviewBox from "@/Pages/Sites/FeatureSections/CheapPackagePreviewBox";
import PackagePricingBoxes from "@/Pages/Sites/FeatureSections/PackagePricingBoxes";
import CTAR2DiveIn from "@/Pages/Sites/FeatureSections/CTAR2DiveIn";

const secureIcon = defineComponent({
  render() {
    return h('svg', {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, [
      h('path', {
        d: 'M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      })
    ]);
  }
});

const features = [
  {
    name: 'Early Expiry Notifications', // __('Early Expiry Notifications')
    description: 'SSL monitoring ensures that you receive timely alerts well in advance of certificate expiration. This allows you to take immediate action and renew your certificates before they lapse, avoiding potential security risks and maintaining uninterrupted service.', // __('SSL monitoring ensures that you receive timely alerts well in advance of certificate expiration. This allows you to take immediate action and renew your certificates before they lapse, avoiding potential security risks and maintaining uninterrupted service.')
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M9 13.5L11 15.5L15.5 11M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Enhanced Security', // __('Enhanced Security')
    description: 'Keeping your SSL certificates up to date ensures the encryption and protection of data transmitted between your website and its users. SSL monitoring enables you to maintain a secure connection and safeguard sensitive information, mitigating the risk of unauthorized access or data breaches.', // __('Keeping your SSL certificates up to date ensures the encryption and protection of data transmitted between your website and its users. SSL monitoring enables you to maintain a secure connection and safeguard sensitive information, mitigating the risk of unauthorized access or data breaches.')
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Maintaining Trust', // __('Maintaining Trust')
    description: 'SSL certificates are visual indicators of a secure website, instilling confidence and trust in your users. By actively monitoring your SSL certificates, you demonstrate your commitment to security and reliability, building trust with your audience and enhancing your brand reputation.', // __('SSL certificates are visual indicators of a secure website, instilling confidence and trust in your users. By actively monitoring your SSL certificates, you demonstrate your commitment to security and reliability, building trust with your audience and enhancing your brand reputation.')
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M14 17L17 14L14 11M10 7L7 10L10 13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
  {
    name: 'Compliance and Auditing', // __('Compliance and Auditing')
    description: 'SSL monitoring helps you stay compliant with industry standards and regulations. By ensuring the validity of your SSL certificates, you can meet the requirements set forth by governing bodies and pass security audits with ease.', // __('SSL monitoring helps you stay compliant with industry standards and regulations. By ensuring the validity of your SSL certificates, you can meet the requirements set forth by governing bodies and pass security audits with ease.')
    icon: defineComponent({
      render() {
        return h('svg', {
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg'
        }, [
          h('path', {
            d: 'M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01',
            stroke: 'currentColor',
            'stroke-width': '2',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          })
        ]);
      }
    }),
  },
]
</script>